import type { Feature, Polygon } from "geojson";
import type { MapObjectProperties } from "@iventis/map-types";
import type { BehaviorSubject } from "rxjs";
import { Status } from "@iventis/domain-model/model/status";
import { StyleType } from "@iventis/domain-model/model/styleType";
import { createStaticStyleValue } from "@iventis/layer-style-helpers";
import { AreaStyle } from "@iventis/domain-model/model/areaStyle";
import { AreaDimension } from "@iventis/domain-model/model/areaDimension";
import { LayerStorageScope, MapState } from "../../types/store-schema";
import type { DomainLayer } from "../../state/map.state.types";
import { Layer } from "./layer";
import { ViewByStatus } from "../../types/layer-view-by";
import { defaultAreaStyle } from "../../utilities/default-style-values";

export abstract class ModelStandStemLayer extends Layer<Feature<Polygon, MapObjectProperties>[], AreaStyle> {
    protected readonly layerId: string;

    protected readonly sourceId: string;

    protected readonly stemLayer: DomainLayer;

    constructor(state$: BehaviorSubject<MapState>, layerId: string) {
        super(state$);
        this.layerId = `${layerId}-model-stand-stem`;
        this.sourceId = this.layerId;
        this.stemLayer = this.createStemLayer();
    }

    private createStemLayer(): DomainLayer {
        return {
            id: this.layerId,
            status: Status.Active,
            mapId: "",
            visible: true,
            locked: false,
            imported: false,
            name: "model stand stem",
            styleType: StyleType.Area,
            areaStyle: {
                ...defaultAreaStyle,
                dimension: createStaticStyleValue(AreaDimension.Three),
                colour: createStaticStyleValue("black"),
                opacity: createStaticStyleValue(0.9),
                // Overwritten by Mapbox style as we are using both a layer and object value to determine it
                height: createStaticStyleValue(0),
            },
            lineStyle: undefined,
            pointStyle: undefined,
            iconStyle: undefined,
            modelStyle: undefined,
            lineModelStyle: undefined,
            areaModelStyle: undefined,
            previewIconUrl: "",
            dataFields: [],
            tooltipDataFieldIds: [],
            createdByUserId: "",
            createdByUserName: "",
            createdAt: undefined,
            lastUpdatedByUserId: "",
            lastUpdatedByUserName: "",
            lastUpdatedAt: undefined,
            viewBy: ViewByStatus.OBJECT,
            source: this.sourceId,
            stamp: "",
            selected: false,
            storageScope: LayerStorageScope.LocalOnly,
            remote: false,
        };
    }
}
